import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const Plane = () => {
  const ref = useRef();
  const model = useGLTF(defineSrc('plane.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('plane-light.json'));
  const plane = model.scene.getObjectByName('Plane_6_update');
  const {
    mixer,
    clips
  } = useAnimations(model.animations, ref);
  useFrame(() => {
    model.materials['Tapestry WebGL'].map.offset.y += 0.018;
    plane.position.x = 0.45;
    plane.position.y = 7.5;
    mixer.clipAction(clips[0]).play();
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: ref,
      scale: 1.3,
      position: [0, -7, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Plane as default };
//# sourceMappingURL=Plane-BYWAvZ3D.esm.js.map
